"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSentenceCase = toSentenceCase;
/**
 * Converts a string from camelCase or kebab-case to sentence case.
 * @param str - The string to convert (e.g., "helloWorld" or "hello-world")
 * @returns The converted string in sentence case (e.g., "Hello world")
 *
 * @example
 * toSentenceCase("helloWorld") // "Hello world"
 * toSentenceCase("hello-world") // "Hello world"
 * toSentenceCase("someAPIKey") // "Some API key"
 */
function toSentenceCase(str) {
    if (!str)
        return '';
    // Handle kebab-case: replace hyphens with spaces
    // Handle camelCase: insert space before capital letters
    const result = str
        .replace(/-/g, ' ') // Replace hyphens with spaces
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Insert space before capitals in camelCase
        .toLowerCase(); // Convert all to lowercase
    // Capitalize first letter
    return result.charAt(0).toUpperCase() + result.slice(1);
}
